import { useState } from "react";
import { renderArticleRichText } from "./renderArticleRichText";

interface FAQItem {
  question: string;
  answer: string;
}

interface ArticleFAQProps {
  faqs: FAQItem[];
  articleTitle: string;
}

export default function ArticleFAQ({ faqs, articleTitle }: ArticleFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <section id="faq" className="mt-10">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <h2 className="mb-2 text-xl font-normal text-gray-900 md:text-2xl">
        Perguntas Frequentes sobre {articleTitle}
      </h2>

      <p className="mb-6 text-sm text-gray-900">
        Respondemos as dúvidas mais comuns para ajudar na sua decisão de compra.
      </p>

      <div className="space-y-3">
        {faqs.map((faq, idx) => (
          <div
            key={idx}
            className={`overflow-hidden rounded-xl border transition-all ${
              openIndex === idx ? "border-sky-100 bg-sky-50" : "border-sky-100 bg-sky-50/60"
            }`}
          >
            <button
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <p className="text-sm font-semibold leading-snug text-gray-900">
                <a id={`faq-${idx}`} className="scroll-mt-24">{faq.question}</a>
              </p>
              <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center">
                <i
                  className={`text-lg text-sky-500 transition-transform duration-200 ${
                    openIndex === idx ? "ri-subtract-line" : "ri-add-line"
                  }`}
                ></i>
              </div>
            </button>

            {openIndex === idx && (
              <div className="px-5 pb-5">
                <div className="space-y-2 text-gray-900">
                  {renderArticleRichText(faq.answer, {
                    paragraphClassName: "text-sm leading-relaxed text-gray-900",
                    bulletItemClassName: "text-sm leading-relaxed text-gray-900",
                    standaloneBoldClassName: "mt-4 mb-1 text-sm font-bold text-gray-900",
                  })}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}